export const BOOKING_STATUS = Object.freeze({
  DRAFT: 500,
  UNALLOCATED: 10000,
  PENDING: 10100,
  ALLOCATED: 10200,
  AWAITING_PICKUP: 10300,
  BEING_COLLECTED: 10400,
  TRANSPORT_TO_GARAGE: 10500,
  AT_GARAGE: 10600,
  WORK_COMPLETE: 10700,
  PAID: 10800,
  BEING_RETURNED: 10900,
  CLOSED: 11000,
  CANCELLED: 20000,
  GARAGE_DECLINED: 20100,
  BOOKING_CHANGE: 20200,
  UNPAID: 20300,
  DISPUTE: 20400,
});

export const GARAGE_STATUS = Object.freeze({
  DRAFT: 'GARAGE_DRAFT',
  FIXTER_REVIEW: 'FIXTER_REVIEW',
  CUSTOMER_REVIEW: 'CUSTOMER_REVIEW',
  CUSTOMER_REVIEWED: 'CUSTOMER_REVIEWED',
  WORK_STARTED: 'WORK_STARTED',
  WORK_COMPLETE: 'WORK_COMPLETE',
});

export const INVOICE_STATUS = Object.freeze({
  UNSUBMITTED: 'unsubmitted',
  SUBMITTED: 'submitted',
  ON_HOLD: 'on_hold',
  AWAITING_APPROVAL: 'awaiting_approval',
  PAID: 'paid',
});

export const INVITE_STATUS = Object.freeze({
  ACCEPTED: 'accepted',
  DRAFT: 'draft',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  DECLINED: 'declined',
  REVIEW: 'review',
});

export const TOKEN_EXPIRED = Symbol('token-expired');

export const CLEAR_STATE = '@maia/Booking/CLEAR_STATE';

export const LOAD_BOOKING = '@maia/Booking/LOAD_BOOKING';
export const LOAD_BOOKING_SUCCESS = '@maia/Booking/LOAD_BOOKING_SUCCESS';
export const LOAD_BOOKING_ERROR = '@maia/Booking/LOAD_BOOKING_ERROR';
export const UPDATE_BOOKING = '@maia/Booking/UPDATE_BOOKING';

export const PATCH_BOOKING = '@maia/Booking/PATCH_BOOKING';
export const PATCH_BOOKING_SUCCESS = '@maia/Booking/PATCH_BOOKING_SUCCESS';
export const PATCH_BOOKING_ERROR = '@maia/Booking/PATCH_BOOKING_ERROR';
export const CANCEL_BOOKING = '@maia/Booking/CANCEL_BOOKING';

export const CHARGE_PAYMENT = '@maia/Booking/CHARGE_PAYMENT';
export const CHARGE_PAYMENT_ERROR = '@maia/Booking/CHARGE_PAYMENT_ERROR';
export const CHARGE_PAYMENT_SUCCESS = '@maia/Booking/CHARGE_PAYMENT_SUCCESS';

export const CHARGE_INSTALMENT = '@maia/Booking/CHARGE_INSTALMENT';
export const CHARGE_INSTALMENT_ERROR = '@maia/Booking/CHARGE_INSTALMENT_ERROR';
export const CHARGE_INSTALMENT_SUCCESS = '@maia/Booking/CHARGE_INSTALMENT_SUCCESS';

export const ADD_NOTE = '@maia/Booking/ADD_NOTE';
export const ADD_NOTE_SUCCESS = '@maia/Booking/ADD_NOTE_SUCCESS';

export const BOOKING_CHANGED = '@maia/Booking/BOOKING_CHANGED';
export const RELOAD_BOOKING = '@maia/Booking/RELOAD_BOOKING';

export const EDIT_CUSTOMER_DETAILS_SUCCESS = '@maia/Booking/Customer/EDIT_CUSTOMER_DETAILS_SUCCESS';
export const EDIT_CUSTOMER_PROMO_SUCCESS = '@maia/Booking/Customer/EDIT_CUSTOMER_PROMO_SUCCESS';

export const AUTH_USER_SUCCESS = '@maia/Booking/AUTH_USER_SUCCESS';

export const JOB_INVITE_REQUEST = '@maia/GarageAllocation/JOB_INVITE_REQUEST';
export const JOB_INVITE_PATCH = '@maia/GarageAllocation/JOB_INVITE_PATCH';
export const JOB_INVITE_SUCCESS = '@maia/GarageAllocation/JOB_INVITE_SUCCESS';
export const JOB_INVITE_ERROR = '@maia/GarageAllocation/JOB_INVITE_ERROR';

export const EDIT_GARAGE_BILL_STATUS_REQUEST = '@maia/GarageBill/EDIT_GARAGE_BILL_STATUS_REQUEST';
export const EDIT_GARAGE_BILL_STATUS_SUCCESS = '@maia/GarageBill/EDIT_GARAGE_BILL_STATUS_SUCCESS';
export const EDIT_GARAGE_BILL_STATUS_FAILURE = '@maia/GarageBill/EDIT_GARAGE_BILL_STATUS_FAILURE';

export const GARAGE_BILL_PDF_URL_REQUEST = '@maia/GarageBill/GARAGE_BILL_PDF_URL_REQUEST';
export const GARAGE_BILL_PDF_URL_SUCCESS = '@maia/GarageBill/GARAGE_BILL_PDF_URL_SUCCESS';
export const GARAGE_BILL_PDF_URL_FAILURE = '@maia/GarageBill/GARAGE_BILL_PDF_URL_FAILURE';
